import React, { useEffect, useState } from "react";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";

import {
  Container,
  ContentSquad,
  Title,
  Email,
  IndicationsComponent,
  Name,
  Position,
  RankingFrame,
  RestIndications,
  RestItem,
  RestList,
  RestName,
  RestPosition,
  Top2Container,
  TopCard,
  ContainerTotal,
  TotalLabel,
  TotalNumber,
} from "./styled";
import { producaov2 } from "../../../services/apis";
import { FaUserCheck } from "react-icons/fa";
import { useRouter } from "../../../hooks/router";

const Indications = () => {
  const [ranking, setRanking] = useState([
    {
      email: "exemple@exemple.com",
      nome: "EXEMPLE DEV",
      indicacoes: 10,
      foto: "dasdsadasd",
    },
  ]);
  const router = useRouter();
  const [total, setTotal] = useState(0);

  async function getData(newEvento) {
    try {
      const data = await producaov2.get(
        `/admin/inscricoes-eventos/wins?id_evento=${newEvento}`
      );

      setRanking(data.data.dados);
      setTotal(data.data.total);
    } catch (error) {
      console.log("Erro ao buscar dados:", error);
    }
  }

  useEffect(() => {
    const { id_evento } = router.query;
    const newEvento = Number(id_evento);

    if (newEvento) {
      getData(newEvento);

      const interval = setInterval(() => {
        getData(newEvento);
      }, 5 * 60 * 1000);

      return () => {
        console.log("Limpando intervalo");
        clearInterval(interval);
      };
    }
  }, []);

  // Separar top 2 e os demais
  const top2 = ranking.slice(0, 2);
  const rest = ranking.slice(2, 100);

  return (
    <Container>
      <AdminMenu />
      <ContentSquad>
        <ContainerTotal>
          <TotalLabel>Total de inscrições realizadas</TotalLabel>
          <TotalNumber>{total}</TotalNumber>
        </ContainerTotal>
        <RankingFrame>
          <Top2Container>
            {top2.map((user, idx) => (
              <TopCard key={user.email} highlight={idx === 0}>
                <Position>{idx + 1}º</Position>
                <img
                  src={
                    user.foto ||
                    "https://ui-avatars.com/api/?name=" +
                      encodeURIComponent(user.nome)
                  }
                  alt={user.nome}
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginBottom: 8,
                    border: "2px solid #eee",
                  }}
                />
                <Name>{user.nome}</Name>
                <Email>{user.email}</Email>
                <IndicationsComponent>
                  {user.indicacoes} indicações
                </IndicationsComponent>
              </TopCard>
            ))}
          </Top2Container>
          <RestList>
            {rest.map((user, idx) => (
              <RestItem key={user.email}>
                <RestPosition>{idx + 3}º</RestPosition>
                <img
                  src={
                    user.foto ||
                    "https://ui-avatars.com/api/?name=" +
                      encodeURIComponent(user.nome)
                  }
                  alt={user.nome}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: 8,
                    border: "1px solid #eee",
                  }}
                />
                <RestName>{user.nome}</RestName>
                <RestIndications>{user.indicacoes} indicações</RestIndications>
              </RestItem>
            ))}
          </RestList>
        </RankingFrame>
      </ContentSquad>
    </Container>
  );
};

export default withRouter(Indications);
